import {
  QuestionnaireBaseSchema,
  type QuestionnaireBaseInput,
  type QuestionnaireBaseOutput,
} from './questionnaire-base-schema';

export const QuestionnaireShortFormSchema = QuestionnaireBaseSchema;

export type QuestionnaireShortFormInput = QuestionnaireBaseInput;
export type QuestionnaireShortFormOutput = QuestionnaireBaseOutput;
